import { render, staticRenderFns } from "./ThePublicFooter.vue?vue&type=template&id=0749b9d4&"
import script from "./ThePublicFooter.vue?vue&type=script&lang=js&"
export * from "./ThePublicFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThePublicFooter.vue?vue&type=style&index=0&id=0749b9d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports